import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TrialInfoPopupState = {
    isTrialInfoPopupOpen: boolean;
    isRoleHasUltimateRate: boolean;
};

const initialState: TrialInfoPopupState = {
    isTrialInfoPopupOpen: false,
    isRoleHasUltimateRate: false,
};

export const trialInfoPopupSlice = createSlice({
    name: 'trialInfoPopup',
    initialState,
    reducers: {
        setTrialInfoPopupOpen: (
            state,
            action: PayloadAction<{
                isTrialInfoPopupOpen: boolean;
                isRoleHasUltimateRate: boolean;
            }>,
        ) => {
            state.isTrialInfoPopupOpen = action.payload.isTrialInfoPopupOpen;
            state.isRoleHasUltimateRate = action.payload.isRoleHasUltimateRate;
        },
    },
});

export const { setTrialInfoPopupOpen } = trialInfoPopupSlice.actions;

export default trialInfoPopupSlice.reducer;
